import React, {createRef} from 'react';
import {Field, Form, Formik} from "formik";
import * as Yup from "yup";
import {formatRut, validateEmail, validateLegalRut, validateRequired} from "shared/utils";
import {MailIcon} from "components/style-guide/icons";
import {FormikInput} from "components/style-guide/form/formik-input/FormikInput";
import {Button, GoogleRecaptcha, TextArea} from "components/index";
import clsx from "clsx";
import PhoneInput from "components/style-guide/form/phone-input/PhoneInput";

import styles from './contact.module.scss';

export const ContactForm = ({sendContactInfo}) => {
    const ref = createRef();
    const recaptchaRef = createRef();

    return (
        <div className={styles.container}>
            <h3>¿Su empresa necesita un convenio para la compra de reportes?</h3>
            <p>Inserta los datos y contactaremos de inmediato.</p>
            <Formik
                innerRef={ref}
                initialValues={{}}
                onSubmit={(values) => {
                    sendContactInfo?.(values);
                    ref.current.resetForm();
                    recaptchaRef?.current?.reset();
                }}
                validationSchema={Yup.object().shape({
                    rut: validateLegalRut,
                    email: validateEmail,
                    name: validateRequired('El nombre es requerido.').contactName("El nombre no es válido."),
                    phone: Yup.lazy((value, context) => {
                        return Yup.string().nullable().phone(context.parent.countryCode)
                    }),
                    recaptcha: Yup.string().required('Verificación de Google Recaptcha requerida.'),
                    comments: Yup.string().nullable().max(250, "La cantidad máxima de caracteres es 250.")
                })}>
                {
                    formik => {
                        const {setFieldValue, setFieldTouched, isValid, values} = formik;

                        return (
                            <Form className={styles.formContainer}>
                                <FormikInput
                                    wrapperClassName=""
                                    name="rut"
                                    label="RUT"
                                    setFormat={event => {
                                        setFieldValue('rut', formatRut(values['rut']));
                                        setTimeout(() => setFieldTouched('rut', true, false));
                                    }}
                                    required/>
                                <FormikInput wrapperClassName="" name="name" label="Nombre Empresa" required/>

                                <FormikInput
                                    wrapperClassName=""
                                    required
                                    prefixIcon={(<MailIcon fill="#9FA6B2"/>)} prefixTop={39} inputLeft={36}
                                    label="Correo Electrónico"
                                    name="email"
                                />

                                <FormikInput
                                    wrapperClassName={''}
                                    Component={PhoneInput}
                                    country={'cl'}
                                    name="phone"
                                    label="Teléfono"
                                    onChange={(v, phoneDetails) => {
                                        setFieldValue('phone', v, phoneDetails.countryCode);
                                        setFieldValue('countryCode', phoneDetails.countryCode.toUpperCase());
                                    }}
                                />

                                <FormikInput
                                    wrapperClassName="fullwidth"
                                    name="comments"
                                    label="Comentario"
                                    Component={TextArea}/>

                                <div className="col-sm flex flex-center fullwidth mt-2">
                                    <Field name="recaptcha">
                                        {({meta, form}) => (
                                            <>
                                                <GoogleRecaptcha ref={recaptchaRef} onChange={(e) => {
                                                    setFieldValue('recaptcha', e || '');
                                                }}/>
                                                {meta.touched && meta.error &&
                                                    <small
                                                        className={clsx('form-text is-invalid invalid-feedback d-flex')}>{meta.error}
                                                    </small>}
                                            </>
                                        )}
                                    </Field>
                                </div>

                                <div className="flex flex-center fullwidth mt-4">
                                    <Button label="Enviar" type="submit" disabled={!isValid}/>
                                </div>
                            </Form>
                        )
                    }
                }
            </Formik>
        </div>
    );
};
